var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#C8102E;}\r\n\t.st2{fill:#1D428A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.4,200.4c0-86.9,70.4-157.3,157.3-157.3S357,113.5,357,200.4s-70.4,157.3-157.3,157.3 S42.4,287.3,42.4,200.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.8,56.1c-79.6,0-144.3,64.7-144.3,144.3s64.7,144.3,144.3,144.3S344.1,280,344.1,200.4 C344.1,120.9,279.3,56.1,199.8,56.1 M304.1,120.3c16.5,21.4,25.9,47,27.2,73.9h-54.4C278.2,167.2,287.6,141.7,304.1,120.3  M95.5,120.3c16.5,21.4,25.9,47,27.3,73.9H68.2C69.6,167.1,78.9,141.7,95.5,120.3 M95.5,280.6c-16.5-21.4-25.9-47-27.2-73.9h54.4 C121.4,233.7,112,259.2,95.5,280.6 M206.1,332v-37.7h-12.7V332c-34.3-1.6-66-16.3-89.6-41.4c19.3-24.1,30.1-53,31.4-83.7v-12.7 c-1.3-30.7-12.2-59.6-31.4-83.7c23.6-25.1,55.3-39.8,89.6-41.4v37.4h12.7V68.9c34.3,1.6,66,16.3,89.6,41.4 c-19.3,24.1-30.1,53-31.4,83.7v12.7c1.3,30.7,12.2,59.6,31.4,83.7C272.1,315.6,240.3,330.3,206.1,332 M304.1,280.6 c-16.5-21.4-25.9-47-27.3-73.9h54.4C329.9,233.7,320.6,259.2,304.1,280.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "167.6,140 167.6,260.4 232,260.4 232,243.9 184.8,243.9 184.8,140  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M253.8,180.3v-49.6c0-7.5-3-10.5-10.3-10.5h-87.6c-7.2,0-10.2,3.1-10.2,10.5v139.4c0,7.5,3,10.5,10.2,10.5 h87.6c7.3,0,10.3-3.1,10.3-10.5v-49.7h-17.4v44.9H163V135.5h73.5v44.8L253.8,180.3L253.8,180.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232,239.2V140h-41.9l-0.4,99.2h16.7l0.3-30.9h8.5l-0.1,30.9H232z M215.1,191.7h-8.4v-35.2h8.4V191.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLac);
export default __webpack_public_path__ + "static/media/LAC.e5812b790d7e2c4746bb26b195ca6680.svg";
export { ForwardRef as ReactComponent };